import * as ExcelJS from "exceljs"; // TODO: remove this and call api?
import { PeriodData } from "../shared/types";
import { calculatePercentageOf, formatCurrency, toPercentage } from "../shared/utils";
import { createExcelFileDownloadFromRawData } from "../../../lib/supportFunctions";

type RowTotalReservations = Record<string, { totalReservations: number; totalRevenue: number }>;
type RowTotalFunctionality = Record<
  string,
  Record<
    string,
    {
      totalReservations: number;
      totalRevenue: number;
    }
  >
>;

export async function jsonToXlsx(data: PeriodData, filename: string) {
  const workbook = new ExcelJS.Workbook();

  // SHEET 1: ByReservation
  const sheetByReservation = workbook.addWorksheet("ByReservation");
  sheetByReservation.columns = [
    { header: "Period", key: "period", width: 25 },
    { header: "Group", key: "group", width: 25 },
    { header: "Hotel", key: "hotel", width: 25 },
    { header: "Total Reservations", key: "totalReservations", width: 20 },
    { header: "Total Revenue", key: "totalRevenue", width: 20 },
  ];
  sheetByReservation.getRow(1).font = { bold: true };

  // Add rows to ByReservation
  const totalsByReservation: RowTotalReservations = {};
  for (const [groupName, hotels] of Object.entries(data.groups)) {
    totalsByReservation[groupName] = { totalReservations: 0, totalRevenue: 0 };
    for (const [hotelName, hotelData] of Object.entries(hotels)) {
      sheetByReservation.addRow({
        period: data.period,
        group: groupName,
        hotel: hotelName,
        totalReservations: hotelData.byReservation.totalReservations,
        totalRevenue: hotelData.byReservation.totalRevenueAsString,
      });
      totalsByReservation[groupName] = {
        totalReservations:
          totalsByReservation[groupName].totalReservations +
          hotelData.byReservation.totalReservations,
        totalRevenue:
          totalsByReservation[groupName].totalRevenue + hotelData.byReservation.totalRevenue,
      };
    }
  }

  sheetByReservation.addRow([]);

  // Add totals
  for (const [groupName, total] of Object.entries(totalsByReservation)) {
    sheetByReservation.addRow({
      period: data.period,
      group: groupName,
      hotel: "Total",
      totalReservations: total.totalReservations,
      totalRevenue: formatCurrency(total.totalRevenue),
    }).font = { bold: true };
  }

  // SHEET 2: ByFunctionality
  const sheetByFunctionality = workbook.addWorksheet("ByFunctionality");
  sheetByFunctionality.columns = [
    { header: "Period", key: "period", width: 25 },
    { header: "Group", key: "group", width: 25 },
    { header: "Hotel", key: "hotel", width: 25 },
    { header: "Tag", key: "tag", width: 25 },
    { header: "Total Reservations", key: "totalReservations", width: 20 },
    { header: "Total Revenue", key: "totalRevenue", width: 20 },
    { header: "% Reservations", key: "percentageReservations", width: 15 },
    { header: "% Revenue", key: "percentageRevenue", width: 15 },
  ];
  sheetByFunctionality.getRow(1).font = { bold: true };

  // Add rows to ByFunctionality
  const totalsByFunctionality: RowTotalFunctionality = {};
  for (const [groupName, hotels] of Object.entries(data.groups)) {
    totalsByFunctionality[groupName] = {};
    for (const [hotelName, hotelData] of Object.entries(hotels)) {
      for (const it of hotelData.byFunctionality) {
        sheetByFunctionality.addRow({
          period: data.period,
          group: groupName,
          hotel: hotelName,
          tag: it.tag,
          totalReservations: it.totalReservations,
          totalRevenue: it.totalRevenueAsString,
          percentageReservations: it.percentageReservationsAsString,
          percentageRevenue: it.percentageRevenueAsString,
        });
        if (!totalsByFunctionality[groupName][it.tag]) {
          totalsByFunctionality[groupName][it.tag] = { totalReservations: 0, totalRevenue: 0 };
        }
        totalsByFunctionality[groupName][it.tag] = {
          totalReservations:
            totalsByFunctionality[groupName][it.tag].totalReservations + it.totalReservations,
          totalRevenue: totalsByFunctionality[groupName][it.tag].totalRevenue + it.totalRevenue,
        };
      }
    }
  }

  sheetByFunctionality.addRow([]);

  // Add totals
  for (const [groupName, tagsTotal] of Object.entries(totalsByFunctionality)) {
    for (const [tag, total] of Object.entries(tagsTotal)) {
      const totalReservationPercentage = calculatePercentageOf(
        total.totalReservations,
        totalsByReservation[groupName].totalReservations
      );
      const totalRevenuePercentage = calculatePercentageOf(
        total.totalRevenue,
        totalsByReservation[groupName].totalRevenue
      );
      sheetByFunctionality.addRow({
        period: data.period,
        group: groupName,
        hotel: "Total",
        tag,
        totalReservations: total.totalReservations,
        totalRevenue: formatCurrency(total.totalRevenue),
        percentageReservations: toPercentage(totalReservationPercentage),
        percentageRevenue: toPercentage(totalRevenuePercentage),
      }).font = { bold: true };
    }
  }

  // Write to file
  const buffer = await workbook.xlsx.writeBuffer();
  createExcelFileDownloadFromRawData(buffer, filename);
}
